<template>
  <div class="locale-changer">
    <select v-model="locale" @change="updateLang($event.target.value)">
      <option
        v-for="(lang, i) in langs"
        :selected="lang == locale"
        :key="`Lang${i}`"
        :value="lang"
      >
        {{ lang }}
      </option>
    </select>
  </div>
</template>

<script>
import * as wijmo from "@grapecity/wijmo";
export default {
  name: "lang-switcher",
  data() {
    return {
      langs: ["fr-FR", "en-GB", "en-US"],
      locale: this.$i18n.locale,
    };
  },
  methods: {
    updateLang(value) {
      this.$i18n.locale = value;
      if (this.$i18n.locale.startsWith("fr")) this.loadCulture("fr");
      else this.loadCulture("en");
    },
    loadCulture(culture) {
      // apply new culture to page
      let url = `https://cdn.grapecity.com/wijmo/5.latest/controls/cultures/wijmo.culture.${culture}.js`,
        scripts = document.getElementsByTagName("script");

      for (let i = 0; i < scripts.length; i++) {
        let script = scripts[i];
        if (script.src.indexOf("/cultures/wijmo.culture.") > -1) {
          script.parentElement.removeChild(script);
          break;
        }
      }

      let script = document.createElement("script");
      script.onload = () => {
        this.$forceUpdate();
        // invalidate all Wijmo controls to accept new culture
        wijmo.Control.invalidateAll();
      };
      script.src = url;
      document.head.appendChild(script);
    },
  },
  mounted() {
    console.log("i18n locale in langSwitcher init: ", this.$i18n.locale);
  },
};
</script>
